module.exports = __webpack_public_path__ + "img/sound_white_mod.a276b82c.svg";